import * as React from 'react';
import { TextField } from '@fluentui/react/lib/TextField';

import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';
import { MarqueeSelection } from '@fluentui/react/lib/MarqueeSelection';

import { format } from 'date-fns';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faApple, faGooglePlay, faStripe } from '@fortawesome/free-brands-svg-icons';
import {
  getCompleteUsersInfo,
  getCompleteUsersInfoByOrganisations,
  getStripeSubscriptionByUserId,
  getUserOrganisationsByEmail
} from '../../firebase';
import { exportToCSV, latestReflection } from '../../utils/helperFunctions';

import { Button, CloseButton, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import {
  Icon,
  DefaultButton,
  IconButton,
  DatePicker,
  DayOfWeek,
  defaultDatePickerStrings,
  Label
} from '@fluentui/react';

import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { toast } from 'react-toastify';
import { faFilter, faFilterCircleXmark, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { TFunction } from 'react-i18next';
import { FirebaseError } from 'firebase/app';
import { CustomTableUsers, FieldQueryType, UserOrganisationsRoles, UserTableHeadersText } from '../../interfaces';

export interface Props {
  t: TFunction<'translation', undefined>;
  userRoles: UserOrganisationsRoles;
}

interface State {
  sourceItems: CustomTableUsers[];
  items: CustomTableUsers[];
  selectedItems: CustomTableUsers[];
  columns: IColumn[];
  loading: boolean;
  showDeleteModal: boolean;
  forceReload: boolean;
  fieldQuery: FieldQueryType;
}

export class DetailsListUsers extends React.Component<Props, State> {
  private _selection: Selection;
  private initialFieldQuery: FieldQueryType = {
    email: '',
    latestReflectionEnd: undefined,
    latestReflectionStart: undefined,

    createdAtStart: undefined,
    createdAtEnd: undefined,
    name: '',
    nrOfCoins: '',
    organisations: '',
    subscription: '',
    treasures: ''
  };
  constructor(props: Props) {
    super(props);

    const columns: IColumn[] = [
      {
        key: 'email',
        name: UserTableHeadersText.email,
        fieldName: 'email',
        minWidth: 180,
        maxWidth: 280,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        onColumnClick: this._onColumnClick,
        data: 'string',
        isPadded: true
      },
      {
        key: 'name',
        name: UserTableHeadersText.name,
        fieldName: 'name',
        minWidth: 180,
        maxWidth: 280,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        onColumnClick: this._onColumnClick,
        data: 'string',
        isPadded: true
      },
      {
        key: 'createdAt',
        name: UserTableHeadersText.createdAt,
        fieldName: 'createdAt',
        minWidth: 95,
        maxWidth: 100,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: 'number',
        onRender: (item: CustomTableUsers) => {
          return <span>{format(new Date(item.createdAt), 'yyyy-MM-dd  HH:mm')}</span>;
        },
        isPadded: true
      },
      {
        key: 'latestReflection',
        name: UserTableHeadersText.latestReflection,
        fieldName: 'latestReflection',
        minWidth: 95,
        maxWidth: 100,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: 'number',
        onRender: (item: CustomTableUsers) => {
          return (
            <span>
              {item.latestReflection !== 0
                ? format(new Date(item.latestReflection), 'yyyy-MM-dd  HH:mm')
                : 'Ej slussat'}
            </span>
          );
        },
        isPadded: true
      },
      {
        key: 'treasures',
        name: UserTableHeadersText.treasures,
        fieldName: 'treasures',
        minWidth: 45,
        maxWidth: 55,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: 'number',
        isPadded: true
      },
      {
        key: 'nrOfCoins',
        name: UserTableHeadersText.nrOfCoins,
        fieldName: 'nrOfCoins',
        minWidth: 45,
        maxWidth: 55,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: 'number',
        isPadded: true
      },
      {
        key: 'organisations',
        name: UserTableHeadersText.organisations,
        fieldName: 'organisations',
        minWidth: 80,
        maxWidth: 185,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: 'number',
        isPadded: true,
        onRender: (item: CustomTableUsers) => {
          return (
            <div className='d-flex flex-column justify-content-start align-items-start'>
              {item.organisations.map((o, index) => (
                <span key={`${o.orgId}-${index}`}>{o.orgName}</span>
              ))}
            </div>
          );
        }
      },
      {
        key: 'subscription',
        name: UserTableHeadersText.subscription,
        fieldName: 'subscription',
        minWidth: 25,
        maxWidth: 35,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: 'any',
        isPadded: true,
        onRender: (item: CustomTableUsers) => {
          return item.subscription === 'APPLE' ? (
            <FontAwesomeIcon icon={faApple} color='rgb(96, 94, 92)' size={'2x'} />
          ) : item.subscription === 'GOOGLE' ? (
            <FontAwesomeIcon icon={faGooglePlay} color='rgb(96, 94, 92)' size='2x' />
          ) : item.subscription ? (
            <a href={item.subscription.stripeLink} target='_blank' rel='noreferrer'>
              {item.subscription.subscriptions.some((s) => !s.ended_at && !s.cancel_at) ? (
                <OverlayTrigger placement='bottom' overlay={<Tooltip>Active Stripe Subscription</Tooltip>}>
                  <FontAwesomeIcon icon={faStripe} size='3x' color='#009dff' />
                </OverlayTrigger>
              ) : (
                <OverlayTrigger placement='bottom' overlay={<Tooltip>Ended/Canceled Stripe Subscription</Tooltip>}>
                  <FontAwesomeIcon icon={faStripe} size='3x' color='rgb(96, 94, 92)' />
                </OverlayTrigger>
              )}
            </a>
          ) : null;
        }
      }
    ];

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({
          selectedItems: this._getSelectionDetails()
        });
      },
      getKey: this._getKey
    });

    this.state = {
      items: [],
      sourceItems: [],
      selectedItems: this._getSelectionDetails(),
      columns,
      loading: false,
      showDeleteModal: false,
      forceReload: false,
      fieldQuery: this.initialFieldQuery
    };
  }

  componentDidMount(): void {
    this.fetchAndConvertUsers();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (prevState.forceReload !== this.state.forceReload) {
      this.fetchAndConvertUsers();
    }

    const recordsAreEqual = Object.keys(prevState.fieldQuery).every(
      (key) => prevState.fieldQuery[key as keyof FieldQueryType] === this.state.fieldQuery[key as keyof FieldQueryType]
    );
    if (!recordsAreEqual) {
      const _email = this.state.fieldQuery.email.trim() !== '' ? this.state.fieldQuery.email.toLowerCase() : undefined;
      const _name = this.state.fieldQuery.name.trim() !== '' ? this.state.fieldQuery.name.toLowerCase() : undefined;
      const _nrOfCoins =
        this.state.fieldQuery.nrOfCoins.trim() !== '' &&
        !isNaN(parseInt(this.state.fieldQuery.nrOfCoins.toLowerCase(), 10))
          ? parseInt(this.state.fieldQuery.nrOfCoins.toLowerCase(), 10)
          : undefined;
      const _treasures =
        this.state.fieldQuery.treasures.trim() !== '' &&
        !isNaN(parseInt(this.state.fieldQuery.treasures.toLowerCase(), 10))
          ? parseInt(this.state.fieldQuery.treasures.toLowerCase(), 10)
          : undefined;
      const _organisations =
        this.state.fieldQuery.organisations.trim() !== ''
          ? this.state.fieldQuery.organisations.toLowerCase()
          : undefined;
      const _createdAtStart = this.state.fieldQuery.createdAtStart
        ? this.state.fieldQuery.createdAtStart.getTime()
        : undefined;
      const _createdAtEnd = this.state.fieldQuery.createdAtEnd
        ? this.state.fieldQuery.createdAtEnd.getTime()
        : undefined;
      const _latestReflectionStart = this.state.fieldQuery.latestReflectionStart
        ? this.state.fieldQuery.latestReflectionStart.getTime()
        : undefined;
      const _latestReflectionEnd = this.state.fieldQuery.latestReflectionEnd
        ? this.state.fieldQuery.latestReflectionEnd.getTime()
        : undefined;
      console.log('_latestReflectionStart:', _latestReflectionStart);
      const _items = this.state.sourceItems.filter((item) => {
        if (_email && !item.email.toLowerCase().includes(_email)) {
          return false;
        }
        if (_name && (!item.name || !item.name.toLowerCase().includes(_name))) {
          return false;
        }
        if (_nrOfCoins && item.nrOfCoins !== _nrOfCoins) {
          return false;
        }
        if (_treasures && item.treasures !== _treasures) {
          return false;
        }
        if (_createdAtStart && !(item.createdAt >= _createdAtStart)) {
          return false;
        }
        if (_createdAtEnd && !(item.createdAt <= _createdAtEnd)) {
          return false;
        }
        if (_latestReflectionStart && (!item.latestReflection || !(item.latestReflection >= _latestReflectionStart))) {
          return false;
        }
        if (_latestReflectionEnd && (!item.latestReflection || !(item.latestReflection <= _latestReflectionEnd))) {
          return false;
        }
        if (
          _organisations &&
          !item.organisations
            .map((o) => o.orgName)
            .toString()
            .toLowerCase()
            .includes(_organisations)
        ) {
          return false;
        }
        return true;
      });
      this.setState({ items: _items });
    }
  }

  public render() {
    const { columns, items, loading, selectedItems, showDeleteModal, fieldQuery } = this.state;

    // TODO: Create a cloud functions for account deletion and use admin SDK and recursively delete userData, memberships, reflections and finally account by passed email & uid
    return (
      <>
        {loading && <Spinner animation='border' />}
        <div className='mt-3 text-start'>
          <div className='d-flex flex-row justify-content-start align-items-start' style={{ width: '100%' }}>
            <div style={{ width: '16rem', height: '75vh' }}>
              <div className='d-flex flex-row justify-content-start align-items-center mb-4' style={{ width: '100%' }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>Filters</p>
                {Object.keys(fieldQuery).some(
                  (k) => fieldQuery[k as keyof FieldQueryType] !== this.initialFieldQuery[k as keyof FieldQueryType]
                ) ? (
                  <FontAwesomeIcon
                    icon={faFilterCircleXmark}
                    style={{ marginLeft: '10px', color: 'greenyellow', fontSize: 25, cursor: 'pointer' }}
                    onClick={() => this.setState({ fieldQuery: this.initialFieldQuery })}
                  />
                ) : (
                  <FontAwesomeIcon icon={faFilter} style={{ marginLeft: '10px', fontSize: 25 }} />
                )}
              </div>

              <div className='field-query-card'>
                <TextField
                  suffix=''
                  label={UserTableHeadersText['email']}
                  value={fieldQuery.email}
                  onChange={(ev, newVal) =>
                    this.setState((prevState) => {
                      this.setState({ fieldQuery: { ...prevState.fieldQuery, email: newVal ?? '' } });
                    })
                  }
                />
              </div>
              <div className='field-query-card'>
                <TextField
                  suffix=''
                  label={UserTableHeadersText['name']}
                  value={fieldQuery.name}
                  onChange={(ev, newVal) =>
                    this.setState((prevState) => {
                      this.setState({ fieldQuery: { ...prevState.fieldQuery, name: newVal ?? '' } });
                    })
                  }
                />
              </div>
              <div className='field-query-card'>
                <TextField
                  suffix=''
                  label={UserTableHeadersText['nrOfCoins']}
                  value={fieldQuery.nrOfCoins}
                  onChange={(ev, newVal) =>
                    this.setState((prevState) => {
                      this.setState({ fieldQuery: { ...prevState.fieldQuery, nrOfCoins: newVal ?? '' } });
                    })
                  }
                />
              </div>
              <div className='field-query-card'>
                <TextField
                  suffix=''
                  label={UserTableHeadersText['treasures']}
                  value={fieldQuery.treasures}
                  onChange={(ev, newVal) =>
                    this.setState((prevState) => {
                      this.setState({ fieldQuery: { ...prevState.fieldQuery, treasures: newVal ?? '' } });
                    })
                  }
                />
              </div>
              <div className='field-query-card'>
                <TextField
                  suffix=''
                  label={UserTableHeadersText['organisations']}
                  value={fieldQuery.organisations}
                  onChange={(ev, newVal) =>
                    this.setState((prevState) => {
                      this.setState({ fieldQuery: { ...prevState.fieldQuery, organisations: newVal ?? '' } });
                    })
                  }
                />
              </div>
              <div className='field-query-card'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <Label>{UserTableHeadersText['createdAt']}</Label>
                  <IconButton
                    iconProps={{ iconName: 'ChromeClose' }}
                    onClick={() =>
                      this.setState((prevState) => {
                        this.setState({
                          fieldQuery: { ...prevState.fieldQuery, createdAtStart: undefined, createdAtEnd: undefined }
                        });
                      })
                    }
                  ></IconButton>
                </div>
                <DatePicker
                  firstDayOfWeek={DayOfWeek.Monday}
                  placeholder='Start...'
                  ariaLabel='Select a date'
                  // DatePicker uses English strings by default. For localized apps, you must override this prop.
                  strings={defaultDatePickerStrings}
                  value={fieldQuery.createdAtStart}
                  onSelectDate={(date) =>
                    this.setState((prevState) => {
                      this.setState({ fieldQuery: { ...prevState.fieldQuery, createdAtStart: date ?? undefined } });
                    })
                  }
                />
                <DatePicker
                  firstDayOfWeek={DayOfWeek.Monday}
                  placeholder='End...'
                  ariaLabel='Select a date'
                  // DatePicker uses English strings by default. For localized apps, you must override this prop.
                  strings={defaultDatePickerStrings}
                  value={fieldQuery.createdAtEnd}
                  onSelectDate={(date) =>
                    this.setState((prevState) => {
                      this.setState({ fieldQuery: { ...prevState.fieldQuery, createdAtEnd: date ?? undefined } });
                    })
                  }
                />
              </div>
              <div className='field-query-card'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <Label>{UserTableHeadersText['latestReflection']}</Label>
                  <IconButton
                    iconProps={{ iconName: 'ChromeClose' }}
                    onClick={() =>
                      this.setState((prevState) => {
                        this.setState({
                          fieldQuery: {
                            ...prevState.fieldQuery,
                            latestReflectionStart: undefined,
                            latestReflectionEnd: undefined
                          }
                        });
                      })
                    }
                  ></IconButton>
                </div>
                <DatePicker
                  firstDayOfWeek={DayOfWeek.Monday}
                  placeholder='Start...'
                  ariaLabel='Select a date'
                  // DatePicker uses English strings by default. For localized apps, you must override this prop.
                  strings={defaultDatePickerStrings}
                  value={fieldQuery.createdAtStart}
                  onSelectDate={(date) =>
                    this.setState((prevState) => {
                      this.setState({
                        fieldQuery: { ...prevState.fieldQuery, latestReflectionStart: date ?? undefined }
                      });
                    })
                  }
                />
                <DatePicker
                  firstDayOfWeek={DayOfWeek.Monday}
                  placeholder='End...'
                  ariaLabel='Select a date'
                  // DatePicker uses English strings by default. For localized apps, you must override this prop.
                  strings={defaultDatePickerStrings}
                  value={fieldQuery.createdAtEnd}
                  onSelectDate={(date) =>
                    this.setState((prevState) => {
                      this.setState({
                        fieldQuery: { ...prevState.fieldQuery, latestReflectionEnd: date ?? undefined }
                      });
                    })
                  }
                />
              </div>
            </div>
            <div style={{ height: '75vh', maxHeight: '75vh', overflowY: 'scroll', width: '100%' }}>
              <div className='d-flex flex-row justify-content-start align-items-center mb-3'>
                <OverlayTrigger
                  placement='bottom'
                  overlay={
                    <Tooltip style={{ width: '25rem', backgroundColor: 'black', paddingRight: '1rem' }}>
                      <div style={{ width: '25rem', wordBreak: 'break-word' }}>
                        Välj användare från tabellen att exportera.
                      </div>
                    </Tooltip>
                  }
                >
                  <DefaultButton
                    text={this.props.t('users.export-as-csv')}
                    onClick={() => this.exportCSVFile()}
                    allowDisabledFocus
                    disabled={selectedItems.length < 1}
                    styles={{ root: { marginLeft: '1rem', borderRadius: '5px' } }}
                  >
                    <Icon {...getFileTypeIconProps({ extension: 'csv', size: 32, imageFileType: 'png' })} />
                  </DefaultButton>
                </OverlayTrigger>
              </div>
              <MarqueeSelection selection={this._selection}>
                <DetailsList
                  items={items}
                  compact={false}
                  columns={columns}
                  selectionMode={SelectionMode.multiple}
                  setKey='multiple'
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  selection={this._selection}
                  selectionPreservedOnEmptyClick={true}
                  enterModalSelectionOnTouch={true}
                  ariaLabelForSelectionColumn='Toggle selection'
                  ariaLabelForSelectAllCheckbox='Toggle selection for all items'
                  checkButtonAriaLabel='select row'
                />
              </MarqueeSelection>
            </div>
          </div>
        </div>
        <Modal show={showDeleteModal} onHide={() => this.setState({ showDeleteModal: false })}>
          <Modal.Header className='d-flex flex-row justify-content-between align-items-center'>
            <Modal.Title>{this.props.t('users.delete-user-modal-title')}</Modal.Title>
            <CloseButton
              style={{ backgroundColor: 'grey' }}
              onClick={() => this.setState({ showDeleteModal: false })}
            />
          </Modal.Header>
          <Modal.Body> {this.props.t('users.delete-user-modal-body')}</Modal.Body>
          <Modal.Footer className='justify-content-between'>
            <Button variant='secondary' onClick={() => this.setState({ showDeleteModal: false })} disabled={loading}>
              {this.props.t('users.cancel')}
            </Button>
            <Button variant='danger' onClick={() => this.deleteUsers()} disabled={loading}>
              {loading ? (
                <Spinner animation='border' size='sm' />
              ) : (
                <FontAwesomeIcon icon={faTrashAlt} style={{ marginRight: '1rem' }} />
              )}
              {this.props.t('users.delete-user')}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  private _getKey(item: any, index?: number): string {
    return item.key;
  }

  private async deleteUsers() {
    const { selectedItems } = this.state;
    this.setState({ loading: true });
    try {
      // await deleteUsersByID(selectedItems);
    } catch (e) {
      console.log('Deleting user failed:', e);
      toast.error(`Deleting user failed \n ${(e as FirebaseError).message}`);
    } finally {
      this.setState({ loading: false, showDeleteModal: false });
    }
  }

  private exportCSVFile() {
    const { selectedItems } = this.state;
    if (selectedItems.length < 1) {
      toast.warn('No rows are selected!');
      return;
    }
    exportToCSV(selectedItems, `enzo-users-${format(new Date(), 'yyyy-MM-dd-HH-mm')}`);
  }

  private _getSelectionDetails(): CustomTableUsers[] {
    return this._selection.getSelection() as CustomTableUsers[];
  }

  private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
    const { columns, items } = this.state;
    const newColumns: IColumn[] = columns.slice();
    const currColumn: IColumn = newColumns.filter((currCol) => column.key === currCol.key)[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
    const newItems = _copyAndSort(items, currColumn.fieldName!, currColumn.isSortedDescending);
    this.setState({
      columns: newColumns,
      items: newItems
    });
  };

  private fetchAndConvertUsers = async () => {
    this.setState({ loading: true });
    try {
      const _users = this.props.userRoles.isSuperAdmin
        ? await getCompleteUsersInfo()
        : this.props.userRoles.adminIn.length > 0
        ? await getCompleteUsersInfoByOrganisations(this.props.userRoles.adminIn.map((i) => i.id))
        : [];
      if (_users) {
        const _customTableUsers = await Promise.all(
          _users.map(async (u) => {
            const _orgs = await getUserOrganisationsByEmail(u.personalInfo.email);
            const _subscription = await getStripeSubscriptionByUserId(u.uid);
            return {
              uid: u.uid,
              email: u.personalInfo.email,
              name: u.personalInfo.name,
              createdAt: u.createdAt.toMillis(),
              latestReflection: latestReflection(
                u.reflection.lastMorningReflection,
                u.reflection.lastEveningReflection
              ),
              nrOfCoins: u.gamification.nrOfCoins,
              subscription: u.googleSubscription ? 'GOOGLE' : u.appleSubscription ? 'APPLE' : _subscription,
              organisations: _orgs,
              treasures: u.history.treasures.length
            } as CustomTableUsers;
          })
        );
        this.setState({ items: _customTableUsers, sourceItems: _customTableUsers });
      }
    } catch (e) {
      console.log('Fetching UsersInfo failed', e);
    } finally {
      this.setState({ loading: false });
    }
  };
}

function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
  const key = columnKey as keyof T;
  return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}
